// Tidy filename-ish titles for display (e.g. an uploaded
// "big_buck_bunny_1080p.mp4" → "big buck bunny 1080p"): drop a common video
// extension and turn underscores into spaces. Real, human-written titles pass
// through unchanged. Shared across the web surfaces (home hero, Studio cards,
// publish modal) so a raw upload filename never leaks into the UI.
export function prettyTitle(t?: string | null): string {
  if (!t) return "";
  return t
    .replace(/\.(mp4|mov|webm|m4v|ogg|mkv|avi)$/i, "")
    .replace(/_+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}
